<template>
  <div class="map-container" :style="{ height: height }">
    <div ref="map" style="height: 100%; width: 100%; border-radius: 10px;"></div>
  </div>
</template>

<script>
import 'leaflet/dist/leaflet.css';
import { LeafletMapController } from '@/core/controller/leaflet_map_controller';

export default {
  name: 'LeafletMap',
  props: {
    markers: { 
      type: Array, 
      default: () => [] 
    },
    height: { 
      type: String, 
      default: '400px' 
    },
    zoom: { 
      type: Number, 
      default: 13 
    },
    center: { 
      type: Array, 
      default: () => [-15.7801, -47.9292] 
    }
  },
  data() {
    return {
      controller: null,
      isInitialized: false,
    };
  },
  watch: {
    markers: {
      handler() {
        if (this.isInitialized) {
          this.controller.updateMarkers();
        }
      },
      deep: true
    }
  },
  mounted() {},
  
  methods: {
    initialize() {
      if (this.isInitialized || !this.$refs.map) {
        return;
      }

      this.controller = new LeafletMapController(this);
      this.controller.initMap();
      
      this.isInitialized = true;
      
      this.controller.updateMarkers();
    },

    invalidateSize() {
      if (this.controller) {
        this.controller.invalidateSize();
      }
    }
  },
  beforeDestroy() {
    if (this.controller) {
      this.controller.destroy();
      this.controller = null;
    }
  }
};
</script>

<style scoped>
.map-container {
  margin-top: 16px;
  margin-bottom: 16px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
}
</style>